import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Filter } from '@brafton/angular-framework-library';
import { ProductsService } from '@brafton/atlas-api-client';
import { Template } from '@brafton/common-framework-library';
import { IPagedList } from '@brafton/skynet-angular-security-service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'shared-filter-panel-templates',
  templateUrl: './filter-panel-templates.component.html',
  styleUrls: ['./filter-panel-templates.component.scss'],
  host: { class: 'filter-panel-templates' },
})
export class SharedFilterPanelTemplatesComponent implements OnInit {
  @Input() templates: Filter[] = [];
  @Output() templatesChange: EventEmitter<Filter[]> = new EventEmitter<Filter[]>();
  @Output() close: EventEmitter<any> = new EventEmitter();

  templates$!: Observable<Template[]>;

  constructor(private productService: ProductsService) { }

  ngOnInit() {
    this.templates$ = this.productService.listTemplates(1, 250, 'ProductHead', true, undefined, 'Editorial,Design,Social,Tech,Consulting,Video,MasterProject', undefined, true).pipe(map((r: IPagedList<Template>) => r.items));
  }

  addProduct(templateDef: Template) {
    if (!this.templates.find((sp) => sp.value === templateDef.baseId)) {
      this.templates.push({ value: templateDef.baseId, displayName: templateDef.module.name + ' > ' + templateDef.name, type: 'template' } as Filter);
    }
    this.templatesChange.emit(this.templates);
  }

  removeProduct(templateDef: Template) {
    const index = this.templates.findIndex((sp) => sp.value === templateDef.baseId);
    if (index > -1) {
      this.templates.splice(index, 1);
    }
    this.templatesChange.emit(this.templates);
  }

  clear() {
    this.templates = [];
    this.templatesChange.emit(this.templates);
  }

  isSelected(templateDef: Template): boolean {
    if (!this.templates) return false;
    if (this.templates.find((sp) => sp.value === templateDef.baseId)) return true;
    else return false;
  }
}
